// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__4KvLv","image":"style_image__M00XR","title":"style_title__p5_oE"};